module.exports = __webpack_public_path__ + "img/resista_protect.6e851623.png";